import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Toggler from 'hoc/toggler'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

// State-controlled dropdown (used primaryl by public pages form)
const TimePickerDropDown = ({
  input,
  isOpen,
  toggle,
  placeholder = 'Select a Time',
  placeholderClassName = 'text-sm',
  inputClassName = 'text-sm text-primary-dark',
  groupClassName,
  errorClassName,
  meta: { touched, error },
  showIcon = false,
  showText = true,
  label,
  labelClassName,
  pickerClassName = '',
}) => {
  const [startDate, setStartDate] = useState(input.value)

  useEffect(() => {
    if (input.value) {
      if (moment(input.value).isValid()) {
        setStartDate(input.value)
      } else {
        // This will handle initial passed data which is not a Date format
        const splittedHourArray = input.value.split(':')
        const mockUpDate = new Date()
        input.onChange(mockUpDate.setHours(...splittedHourArray.map(v => Number(v))))
      }
    }
  }, [input.value])

  const renderDatePicker = () => (
    <div className={`flex justify-center mt-3 border border-primary-orange rounded-lg ${pickerClassName}`}>
      <DatePicker
        showTimeSelect
        showTimeSelectOnly
        calendarClassName="react-datepicker-removed-border-version"
        onChange={date => {
          input.onChange(date)
          setStartDate(date)
          toggle()
        }}
        selected={startDate}
        timeIntervals={60}
        timeCaption="Time"
        dateFormat="h:mm a"
        inline
      />
    </div>
  )

  return (
    <div className={groupClassName}>
      {label && <label className={`block ${labelClassName}`}>
        {label}
      </label>}
      <div className={`w-full border rounded-lg p-3 cursor-pointer ${isOpen ? 'border-primary-orange' : ''}`}>
        <div className="flex w-full justify-between items-center" onClick={toggle}>
          {showIcon && <i className="fa fa-clock-o mr-2" aria-hidden="true"></i>}
          {startDate
            ? <p className={inputClassName}>{moment(startDate).format('h:mm a')}</p>
            : <p className={placeholderClassName}>{placeholder}</p>
          }
          {showText && <span className={`text-xs ${isOpen ? 'text-primary-lightgray' : 'text-primary-orange'}`}>
            Select a Time
          </span>}
          {!showText && (isOpen ? <i className="fa fa-angle-up" aria-hidden="true"></i> : <i className="fa fa-angle-down" aria-hidden="true"></i>)}
        </div>
      </div>
      {isOpen && renderDatePicker()}
      {touched && error && <p className={errorClassName}>{error}</p>}
    </div>
  )
}

TimePickerDropDown.propTypes = {
  options: PropTypes.array,
  input: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.string,
  groupClassName: PropTypes.string,
  placeholderClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  meta: PropTypes.object.isRequired,
  showIcon: PropTypes.bool,
  labelClassName: PropTypes.string,
  showText: PropTypes.bool,
  label: PropTypes.string,
  pickerClassName: PropTypes.string,
}

export default Toggler(TimePickerDropDown)
